import { IPricingWorkload } from "@shared/lib/types/pricingWorkload";
import { Card, Col, Row, Typography } from "@shared/ui";
import {
  ACTIVE_STAT_CARDS,
  CLOSED_STAT_CARDS,
  MY_PRICING_SEGMENT,
  MyPricingSegment,
} from "../lib/constants";
import styles from "./MyPricing.module.scss";

const { Title, Text } = Typography;

type MyPricingStatsSectionProps = {
  segment: MyPricingSegment;
  getStatValue: (key: keyof IPricingWorkload) => number | undefined;
};

export function MyPricingStatsSection({
  segment,
  getStatValue,
}: MyPricingStatsSectionProps) {
  const statCards =
    segment === MY_PRICING_SEGMENT.Open
      ? ACTIVE_STAT_CARDS
      : CLOSED_STAT_CARDS;

  const sectionClassName =
    segment === MY_PRICING_SEGMENT.Open
      ? styles.activeBriefsSection
      : styles.closedBriefsSection;

  return (
    <div className={sectionClassName}>
      <Row gutter={[16, 16]} className={styles.cardsRow}>
        {statCards.map((stat) => (
          <Col key={stat.key} xs={24} sm={12} lg={6}>
            <Card bordered={false} className={styles.statCard}>
              <div className={styles.statHeader}>
                <Text type="secondary">{stat.label}</Text>
              </div>
              <Title level={3} className={styles.statValue}>
                {getStatValue(stat.key) ?? "—"}
              </Title>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
